import React from 'react'
import TextField from '@material-ui/core/TextField'
import { PropTypes } from '@material-ui/core'

interface IProps {
  margin?: PropTypes.Margin
  [key: string]: any
}

const Input = ({ margin, ...props }: IProps) => (
  <TextField style={{ width: '100%' }} {...props} margin={margin || 'normal'} />
)

export default Input
